import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

export const useDeleteContentInTextSet = () => {
  const deleteTextSetContent = useCallback((payload) => {
    const requestParams = {
      method: "DELETE",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    };
    return new Request(
      `${API_BASE_URL}/api/v3/content-membership/`,
      requestParams,
    );
  }, []);

  return useRestMutation(deleteTextSetContent);
};

export default useDeleteContentInTextSet;
